import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {AttributeColumn} from '../../dynamic-form-builder/dynamic-form-builder.component';
import {JsonEditorComponent} from 'ang-jsoneditor';
import {HeadersComponent} from '../../../devex/headers/headers.component';

@Component({
  selector: 'app-devex-signup',
  templateUrl: './devex-signup.component.html',
  styleUrls: ['./devex-signup.component.scss']
})
export class DevexSignupComponent implements OnInit {

  tableDefinition: AttributeColumn[] = [
    {
      name: 'displayName',
      headerDisplayName: 'Display Name',
      type: 'input',
      placeholder: 'Display Name',
      description: 'Display Name',
      disabled: false
    },
    {
      name: 'attributeName',
      headerDisplayName: 'Name',
      type: 'input',
      placeholder: 'Attribute Name',
      selectableOptions: [],
      description: 'Name of the Attribute',
      disabled: false
    },
    {
      name: 'type',
      headerDisplayName: 'Data Type',
      type: 'selector',
      selectableOptions: ['Integer', 'String'],
      disabled: false,
      disabledPlaceholder: 'Please select a Database'
    },
    {
      name: 'fieldType',
      headerDisplayName: 'Form Field Type',
      type: 'selector',
      selectableOptions: ['text_field', 'selectable_field'],
      optionsDisplayNames: ['Text Input', 'Dropdown'],
      disabled: false
    },
    {
      name: 'size',
      headerDisplayName: 'Size',
      type: 'input',
      placeholder: 'Size',
      disabled: false
    },
    {
      name: 'precision',
      headerDisplayName: 'Precision',
      type: 'input',
      placeholder: 'Precision',
      disabled: false
    },
    {
      name: 'attributeType',
      headerDisplayName: 'Key',
      type: 'selector',
      selectableOptions: ['None', 'Primary', 'Unique'],
      disabled: false
    },
    {
      name: 'required',
      headerDisplayName: 'Required',
      type: 'checkbox',
      description: 'Required',
      disabled: false
    },
    {
      name: 'autoIncrement',
      headerDisplayName: 'Auto-Increment',
      type: 'checkbox',
      description: 'Auto-Increment',
      disabled: false
    },
    {
      name: '',
      headerDisplayName: '',
      type: 'more',
      disabled: false,
      dataTypeFilter: []
    }
  ];
  newAttribute = {
    fieldType: 'text_field',
    attributeType: 'None',
    customType: false,
    apiAccessPolicy: 'None',
    attributeName: null,
    type: null,
    array: false,
    size: null,
    precision: null,
    autoIncrement: false,
    defaultValue: null,
    dataStoragePolicy: 'None',
    description: null,
    displayName: '',
    displayPolicy: null,
    required: false,
    subType: [],
    formAttribute: true
  };
  formAttributes: any;


  //database
  selectDatabase: string;
  @Input() datatypes: any;
  dataTypeFilter = [];
  selectedDatatypeFilter: string;
  entityAndVersion: any;
  isSelectedDatabaseNatureNoSQL = false;
  @Input() databases: any;
  //

  ///
  showPathParameters: boolean;
  devExURL = '';
  parameterData = [];
  pathParameter = [];
  isCountOfResAtt: boolean;
  pathParameterSegregator: any;
  find: any;
  pathParameterStopper: any;
  pathParameterValue: any;
  headers = [];
  queryParams = [];
  prerequisites: any;
  showAPIBrowser = true;
  signUpformExecutorModel: any;
  signUpformHttpOperation = '';
  httpOperations = [
    {'name': 'GET'},
    {'name': 'POST'},
    {'name': 'PUT'},
    {'name': 'PATCH'},
    {'name': 'DELETE'}
  ];
  signUpformRawRequestBody: any;
  signUpformRequestBodySelected: any;
  signUpformData: any;

  signUpRequestBody: any;
  signUpRequestBodySelected = 'none';
  signUpRawRequestBody: any;
  signUpFormURLEncodedTrue = true;
  signUpFormDataTrue = true;
  signUpFormData = [];
  signUpHeadersData = [];

  signUpExecutor: any;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild(HeadersComponent) headerChild: HeadersComponent;
  ///

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  @Input() partnerSettingsData: any;
  origRegistrationForm: any;

  componentLoading = false;

  constructor(public platform: LeftpanelComponent) { }

  ngOnInit() {

    this.setTableData();
    this.componentLoading = false;
    this.setDevexConfigs();

    this.signUpExecutor = {};
    this.signUpformExecutorModel = {};
    this.signUpformExecutorModel.apiUrl = this.signUpExecutor.apiUrl;
    this.signUpformExecutorModel.executor_version = this.signUpExecutor.executor_version;
    this.signUpformExecutorModel.executor_method_type = this.signUpExecutor.executor_method_type;
    this.signUpformExecutorModel.queryParams = this.signUpExecutor.queryParams ? this.signUpExecutor.queryParams : [];
    this.signUpformExecutorModel.pathParams = this.signUpExecutor.pathParams;
    this.signUpformExecutorModel.authModel = this.signUpExecutor.authModel;
    this.signUpformExecutorModel.headers = this.signUpExecutor.headers ? this.signUpExecutor.headers : [];

    this.parameterData = this.signUpformExecutorModel.queryParams;
    this.pathParameter = this.signUpformExecutorModel.pathParams;
    this.signUpHeadersData = this.signUpformExecutorModel.headers;

    for (const header of this.signUpHeadersData) {
      if (header['key'] === 'Content-Type') {
        switch (header['value']) {
          case 'multipart/form-data':
            this.signUpformRequestBodySelected = 'form-data';
            this.signUpformData = this.signUpExecutor.requestBody.value;
            this.signUpFormDataTrue = true;
            this.signUpFormURLEncodedTrue = false;
            break;
          case 'application/x-www-form-urlencoded':
            this.signUpformRequestBodySelected = 'x-www-form-urlencoded';
            this.signUpFormData = this.signUpExecutor.requestBody.value;
            this.signUpFormDataTrue = false;
            this.signUpFormURLEncodedTrue = true;
            break;
          case 'application/json':
            this.signUpformRequestBodySelected = 'raw';
            this.signUpRawRequestBody = this.signUpExecutor.requestBody.value;
            break;
          default:
            this.signUpRequestBodySelected = 'none';
            break;
        }
      }
    }
    this.signUpRequestBody = this.signUpExecutor.requestBody;
  }

  setDevexConfigs() {
    for (const env1 of this.partnerSettingsData['environments']) {
      if (env1['name'] === this.partner) {
        const devex = env1['services'].filter(element => element.name === 'Developer Experience');
        for (const config of devex[0]['configurations']) {
          if (config && config !== null && config !== undefined) {
            if (config['name'] === 'Developer Experience') {
              this.formAttributes = config['devex_configurations'] ? config['devex_configurations']['devex_signup'] ? config['devex_configurations']['devex_signup']['form_attributes'] ? config['devex_configurations']['devex_signup']['form_attributes'] : [] : [] : [];
              this.origRegistrationForm = JSON.parse(JSON.stringify(this.formAttributes));
            }
          }
        }
      }
    }
  }

  async filterDataTypes(val) {
    this.getDatabaseTypeForDatabaseName(val);
    this.dataTypeFilter = [];
    this.datatypes.filter(items => {
      if (items.database_type === this.selectedDatatypeFilter) {
        this.dataTypeFilter.push(items);
      }
    });
    if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
      await this.platform.getCustomTypes(val);
      this.entityAndVersion = this.platform.entityAndVersion;
    } else {
      this.entityAndVersion = [];
    }
    if (this.entityAndVersion) {
      for (let i = 0; i < this.entityAndVersion.length; i++) {
        const newType = {
          'database_type': 'mongodb',
          'data_types': [
            {
              'type': this.entityAndVersion[i],
              'default_length': '',
              'min_length': '',
              'max_length': ''
            }]
        };
        this.dataTypeFilter.push(newType);
      }
    }
    this.setTableData();
  }

  setTableData() {
    const values = [];
    for (const dataType of this.dataTypeFilter) {
      if (dataType.data_types[0].type !== 'Object') {
        values.push(dataType.data_types[0].type);
      }
    }
    this.tableDefinition[this.tableDefinition.length - 1].dataTypeFilter = this.dataTypeFilter;
    this.tableDefinition[2].selectableOptions = values;
    if (values.length === 0) {
      this.tableDefinition[2].disabled = true;
    } else {
      this.tableDefinition[2].disabled = false;
    }
  }

  getDatabaseTypeForDatabaseName(val) {
    this.databases.filter(items => {
      if (items.database_name === val) {
        this.selectedDatatypeFilter = items.database_type;
        if (items.hasOwnProperty('is_nosql')) {
          this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
        }
      }
    });
  }

  getBackgroundStyle(val) {
    if (val === 'GET') {
      return 'get-method';
    } else if (val === 'PUT') {
      return 'put-method';
    } else if (val === 'POST') {
      return 'post-method';
    } else if (val === 'DELETE') {
      return 'delete-method';
    } else {
      return 'get-method';
    }
  }

  parameterDataCheck(event: any) {
    // /: calculation
    if (this.devExURL !== event.target.value) {
      this.devExURL = event.target.value;
      this.pathParameterSegregator = this.devExURL.split('/:');
      for (let i = 1; i < this.pathParameterSegregator.length; i++) {
        this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
        this.pathParameterSegregator[i] = this.pathParameterStopper[0];
      }
      // {} for calculation
      let temp2 = this.devExURL.split('/');
      // /: append
      this.pathParameter = [];
      for (let i = 1; i < this.pathParameterSegregator.length; i++) {
        this.pathParameterValue = this.pathParameterSegregator[i];
        this.find = true;
        for (let j = 0; j < this.pathParameter.length; j++) {
          if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
            this.find = false;
          }
        }
        if (this.find === true) {
          this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
        }
      }
      // {} append
      for (let i = 2; i < temp2.length; i++) {
        const init = temp2[i].indexOf('{');
        const fin = temp2[i].indexOf('}');
        if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
          this.pathParameter.push({
            'key': temp2[i].substr(init + 1, fin - init - 1),
            'value': '',
            'description': ''
          });
        }
      }
      // confirm to show the path parameter area.
      if (this.pathParameter.length !== 0) {
        this.showPathParameters = true;
      } else {
        this.showPathParameters = false;
      }
    }
  }

  selectAPI() {
    $('#collapsablePanel').addClass('col-md-3 col-lg-3 col-sm-12 col-xs-12').css('display', 'block');
    $('#devexGeneric').removeClass('col-md-12 col-lg-12 col-sm-12 col-xs-12').addClass('col-md-9 col-lg-9 col-sm-12 col-xs-12');
    $('.URL-Field').removeClass('col-lg-7 col-md-7').addClass('col-lg-9 col-md-9');
    this.showAPIBrowser = false;
  }

  checkQueryParams(event) {
    const tempUrl = event.target.value;
    const seperator = tempUrl.split('/');
    let query: any;
    let finalquery: any;
    if (seperator.length > 0) {
      query = seperator[seperator.length - 1].split('?');
      if (query.length > 1) {
        finalquery = query[query.length - 1].split('&');
        if (finalquery) {
          for (let i = 0; i < finalquery.length; i++) {
            let temp = finalquery[i].split('=');
            let flag = false;
            for (let j = 0; j < this.parameterData.length; j++) {
              if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                flag = true;
                if (temp.length > 1) {
                  this.parameterData[j]['key'] = temp[0];
                  this.parameterData[j]['value'] = temp[1];
                } else {
                  this.parameterData[j]['key'] = temp[0];
                  this.parameterData[j]['value'] = '';
                }
              }
            }
            if (flag === false) {
              if (temp.length > 1) {
                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
              } else {
                this.parameterData.push({key: temp[0], value: '', description: ''});
              }
            }
          }
        }
      }
    }
  }

  async updateFormAttributes() {
    this.signUpformExecutorModel['requestBody'] = await this.headerChild.getRequestBody();
    this.signUpformExecutorModel['partner'] = this.partner;
    this.signUpformExecutorModel['account_id'] = this.account;
    this.signUpformExecutorModel['queryParams'] = this.parameterData;
    this.signUpformExecutorModel['pathParams'] = this.pathParameter;
    this.signUpformExecutorModel['headers'] = this.signUpHeadersData;

    // const payload = {
    //   //'executor_name': this.executor_name,
    //   'executor_type': 'API',
    //   //'executor_version': this.executor_version,
    //   'executor_method_type': this.httpOperation,
    //   'apiUrl': this.httpUrl,
    //   'dataroot': null,
    //   'queryParams': this.parameterData,
    //   'pathParams': this.pathParameter,
    //   'headers': this.headersData,
    //   'requestBody': await this.headerChild.getRequestBody(),
    //   //'executors': this.executors,
    //   'prerequisites': null
    // };
  }
}
